'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = require('preact');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _helpers = require('../../global/helpers/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axiosInstance = _axios2.default.create({
  headers: {
    Pragma: 'no-cache',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

var CartItem = function (_Component) {
  (0, _inherits3.default)(CartItem, _Component);

  function CartItem(props) {
    (0, _classCallCheck3.default)(this, CartItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartItem.__proto__ || Object.getPrototypeOf(CartItem)).call(this, props));

    _this.setQuantity = _this.setQuantity.bind(_this);
    _this.incrementQuantity = _this.incrementQuantity.bind(_this);
    _this.decrementQuantity = _this.decrementQuantity.bind(_this);
    _this.removeItem = _this.removeItem.bind(_this);
    _this.getVariantPropertiesList = _this.getVariantPropertiesList.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CartItem, [{
    key: 'setQuantity',
    value: function setQuantity(event) {
      var _this2 = this;

      var newQuantity = event.target.value;

      axiosInstance.post('/cart/change.js', {
        quantity: newQuantity,
        id: this.props.item.variant_id.toString()
      }).then(function (res) {
        _this2.props.updateCart(res.data);
      }).catch(function (err) {
        alert(err.response.data.description);
      });
    }
  }, {
    key: 'incrementQuantity',
    value: function incrementQuantity() {
      this.props.addToCart(this.props.item.variant_id, 1);
    }
  }, {
    key: 'decrementQuantity',
    value: function decrementQuantity() {
      var _this3 = this;

      axiosInstance.post('/cart/change.js', {
        quantity: this.props.item.quantity - 1,
        id: this.props.item.variant_id.toString()
      }).then(function (res) {
        _this3.props.updateCart(res.data);
      }).catch(function (err) {
        alert(err.response.data.description);
      });
    }
  }, {
    key: 'removeItem',
    value: function removeItem() {
      var _this4 = this;

      axiosInstance.post('/cart/change.js', {
        quantity: "0",
        id: this.props.item.variant_id.toString()
      }).then(function (res) {
        _this4.props.updateCart(res.data);
      }).catch(function (err) {
        alert(err.response.data.description);
      });
    }
  }, {
    key: 'getVariantPropertiesList',
    value: function getVariantPropertiesList() {
      var PROPERTIES_TO_IGNORE = ['style', 'title'];
      var propertiesToShow = this.props.item.options_with_values.filter(function (option) {
        return PROPERTIES_TO_IGNORE.indexOf(option.name.toLowerCase()) === -1;
      });

      return propertiesToShow.map(function (option) {
        return (0, _preact.h)(
          'p',
          { key: option.name + option.value },
          option.name,
          ': ',
          option.value.toUpperCase()
        );
      });
    }
  }, {
    key: 'getResizedImageUrl',
    value: function getResizedImageUrl(image) {
      return image.replace('.jpg', '_300x.jpg');
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item;


      return (0, _preact.h)(
        'div',
        { 'class': 'Minicart__item' },
        (0, _preact.h)(
          'div',
          { 'class': 'Minicart__item__image' },
          (0, _preact.h)('img', { src: this.getResizedImageUrl(item.image), alt: item.product_title })
        ),
        (0, _preact.h)(
          'div',
          { 'class': 'Minicart__item__content', 'data-key': '{item.k}', 'data-inventory': '3' },
          (0, _preact.h)(
            'p',
            { 'class': 'Minicart__item__title' },
            item.product_title
          ),
          (0, _preact.h)(
            'div',
            { 'class': 'Minicart__item__price' },
            (0, _helpers.formatMoneyCents)(item.final_price)
          ),
          (0, _preact.h)(
            'div',
            null,
            this.getVariantPropertiesList()
          ),
          (0, _preact.h)(
            'div',
            { 'class': 'Minicart__item-quantity' },
            (0, _preact.h)(
              'button',
              { 'aria-label': 'Decrease quantity', tabindex: '1', onClick: this.decrementQuantity },
              '-'
            ),
            (0, _preact.h)('input', { type: 'number', value: item.quantity, 'aria-label': 'Adjust quantity', tabindex: '1', onChange: this.setQuantity }),
            (0, _preact.h)(
              'button',
              { 'aria-label': 'Increase quantity', tabindex: '1', onClick: this.incrementQuantity },
              '+'
            )
          ),
          (0, _preact.h)(
            'a',
            { 'class': 'Minicart__item__remove', href: '#', tabindex: '1', onClick: this.removeItem },
            'remove'
          )
        )
      );
    }
  }]);
  return CartItem;
}(_preact.Component);

exports.default = CartItem;